import { api } from './client';
import type { Envelope } from './types';

export interface PaymentReadyRes {
  paymentId: string;
  transferId: string;
  amount: number;
  redirectPcUrl: string;
  redirectMobileUrl: string;
}

export interface PaymentRes {
  id: string;
  transferId: string;
  provider: string;
  amount: number;
  status: 'READY' | 'APPROVED' | 'FAILED' | 'CANCELED';
  approvedAt: string | null;
}

export async function readyKakaoPayment(transferId: string) {
  const { data } = await api.post<Envelope<PaymentReadyRes>>(
    `/settlement-transfers/${transferId}/payments/kakao/ready`,
  );
  return data.data;
}

export async function approvePayment(paymentId: string, pgToken: string) {
  const { data } = await api.post<Envelope<PaymentRes>>(
    `/payments/${paymentId}/approve`,
    { pgToken },
  );
  return data.data;
}

export async function failPayment(paymentId: string, canceled: boolean) {
  const { data } = await api.post<Envelope<PaymentRes>>(
    `/payments/${paymentId}/fail?canceled=${canceled}`,
  );
  return data.data;
}
